import { Component } from '@angular/core';

import { HealthService } from '../../..';

@Component({
  selector: 'pbc-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.css']
})
export class HealthComponent {

  constructor(public health: HealthService) {
  }

}
